export class Host {
   /*
   *
   */
    constructor(
      public id?: number,
      public identificationCode?: string,
      public email?: string,
      public name?: string,
      public surname?: string,
      public mobileNumber?: string,
      public registrationDate?: Date,
      public lastUpdate?: Date,
      public active?: boolean,
      public locale?: string
    ){}
    
}